<div class="fx-col page-container">
  <!-- Top Bar -->
  <mat-toolbar class="page-toolbar"
               color="primary">
    <mat-icon *ngIf="exchangeAction === 'SEND'"
              class="toolbar-icon">
      send
    </mat-icon>
    <mat-icon *ngIf="exchangeAction === 'RETRIEVE'"
              class="toolbar-icon">
      cloud_download
    </mat-icon>
    <mat-icon *ngIf="!exchangeAction"
              class="toolbar-icon">
      image_search
    </mat-icon>
    <span>
      {{pageTitle}}
    </span>
  </mat-toolbar>

  <div class="fx-col fx-gap-16 page-content">

    <!-- ================================================================
         SPOKE LAYOUT: two-tab view (Available Studies | Expired Studies)
         ================================================================ -->
    <ng-container *ngIf="isSpokeUser && senderFacilityId; else standardLayout">
      <mat-tab-group class="spoke-tabs"
                     animationDuration="150ms">

        <mat-tab label="Available Studies">
          <div class="fx-col fx-gap-16 tab-body">

            <!-- Search Panel -->
            <mat-card>
              <app-study-search-form [initialPatientId]="quickFilterPatientId"
                                     [initialPatientName]="initialPatientName"
                                     [isLoading]="isLoading"
                                     (clear)="studies = []; historyStack = []; nextPageToken = null; quickFilterPatientId = null"
                                     (search)="onSearch($event)">
              </app-study-search-form>
            </mat-card>

            <!-- C-MOVE Progress Panel -->
            <mat-card *ngIf="activeMoveJobs.size > 0"
                      class="move-progress-card">
              <div class="move-progress-header">
                <mat-icon class="move-progress-icon">
                  send
                </mat-icon>
                <span class="move-progress-title">
                  Sending Images
                </span>
                <span class="move-progress-subtitle">
                  {{ activeMoveJobs.size }} transfer(s)
                </span>
                <span class="spacer"></span>
                <button *ngIf="allJobsDone"

                        class="done-button"
                        color="primary"

                        mat-flat-button
                        (click)="dismissMoveJobs()">
                  <mat-icon>
                    check
                  </mat-icon>
                  I'm Done
                </button>
              </div>
              <div class="move-job-list">
                <div *ngFor="let job of activeMoveJobsList"
                     class="move-job-row">
                  <div class="move-job-top">
                    <span class="move-job-description">
                      {{job.studyDescription}}
                    </span>
                    <span class="move-job-status"
                          [class.status-failure]="job.status === 'Failure'"
                          [class.status-running]="job.status === 'Running' || job.status === 'Pending' || job.status === 'Retry'"
                          [class.status-success]="job.status === 'Success'">
                      {{ job.status || 'Pending' }}
                      <span *ngIf="job.status === 'Running' && job.progress != null">
                        — {{ job.progress }}%
                      </span>
                    </span>
                  </div>
                  <mat-progress-bar [color]="job.status === 'Failure' ? 'warn' : 'primary'"
                                    [mode]="job.status === 'Running' ? 'determinate' : (job.status === 'Success' || job.status === 'Failure' ? 'determinate' : 'indeterminate')"
                                    [value]="job.status === 'Success' ? 100 : (job.progress || 0)">
                  </mat-progress-bar>
                  <div *ngIf="job.error"
                       class="move-job-error">
                    <mat-icon>
                      error_outline
                    </mat-icon>
                    {{ job.error }}
                  </div>
                </div>
              </div>
            </mat-card>

            <!-- Session Summary (receipt shown after "I'm Done") -->
            <mat-card *ngIf="sessionSummary && activeMoveJobs.size === 0"
                      class="session-summary-card">
              <div class="summary-header">
                <mat-icon class="summary-icon"
                          [class.icon-partial]="sessionSummary.failureCount > 0">
                  {{ sessionSummary.failureCount === 0 ? 'check_circle' : 'warning' }}
                </mat-icon>
                <div class="summary-heading">
                  <span class="summary-title">Send Complete</span>
                  <span class="summary-subtitle">
                    {{ sessionSummary.successCount }} sent to {{ sessionSummary.targetFacilityName }}
                    <span *ngIf="sessionSummary.failureCount > 0"> · {{ sessionSummary.failureCount }} failed</span>
                    · {{ sessionSummary.sentAt | date:'h:mm a' }}
                  </span>
                </div>
                <span class="spacer"></span>
                <button class="done-button"
                        color="primary"
                        mat-flat-button
                        (click)="dismissSummary()">
                  <mat-icon>close</mat-icon>
                  Close
                </button>
              </div>
              <div class="summary-job-list">
                <div *ngFor="let entry of sessionSummary.entries"
                     class="summary-job-row">
                  <mat-icon class="summary-job-icon"
                            [class.icon-success]="entry.status === 'Success'"
                            [class.icon-failure]="entry.status !== 'Success'">
                    {{ entry.status === 'Success' ? 'check_circle_outline' : 'error_outline' }}
                  </mat-icon>
                  <div class="summary-job-text">
                    <span class="summary-job-description">{{ entry.studyDescription }}</span>
                    <span *ngIf="entry.expiresLabel" class="summary-job-expires">{{ entry.expiresLabel }}</span>
                    <span *ngIf="entry.error" class="summary-job-error">{{ entry.error }}</span>
                  </div>
                </div>
              </div>
            </mat-card>

            <!-- Results Area -->
            <mat-card class="fx-flex-grow results-card">
              <app-studies-results-table [activeFiltersDescription]="activeFiltersDescription"
                                         [availableModalities]="availableModalities"
                                         [hasNextPage]="!!nextPageToken"
                                         [hasPreviousPage]="historyStack.length > 0"
                                         [hubShareMap]="hubShareMap"
                                         [isLoading]="isLoading"
                                         [isSpokeUser]="isSpokeUser"
                                         [pageSize]="pageSize"
                                         [patientExistsMap]="patientExistsMap"
                                         [shareMap]="shareMap"
                                         [showSendAction]="showSendAction"
                                         [showSendDialog]="!targetFacilityId"
                                         [showSendUnavailableHint]="showSendUnavailableHint"
                                         [showViewDownloadActions]="exchangeAction !== 'SEND'"
                                         [studies]="studies"
                                         (addPatient)="onAddPatientFromStudy($event)"
                                         (deleteMultiple)="onDeleteMultiple($event)"
                                         (deleteStudy)="onDeleteStudy($event)"
                                         (downloadMultiple)="onDownloadMultiple($event)"
                                         (downloadSingle)="onDownloadSingle($event)"
                                         (filterByPatientId)="onFilterByPatientId($event)"
                                         (limitChange)="onLimitChange($event)"
                                         (nextPage)="onNextPage()"
                                         (previousPage)="onPreviousPage()"
                                         (rowClick)="onRowClick($event)"
                                         (sendMultiple)="onSendMultiple($event.studies, $event.modality)"
                                         (sendStudy)="onSendStudyWithModality($event)"
                                         (viewStudy)="onViewStudy($event)">
              </app-studies-results-table>
            </mat-card>

          </div>
        </mat-tab>

        <mat-tab>
          <ng-template mat-tab-label>
            Expired Studies
            <span *ngIf="expiredShareCount > 0"
                  class="tab-count-badge">
              {{expiredShareCount}}
            </span>
          </ng-template>
          <div class="tab-body">
            <app-study-share-history [shares]="allShares"></app-study-share-history>
          </div>
        </mat-tab>

      </mat-tab-group>
    </ng-container>

    <!-- ================================================================
         STANDARD / HUB LAYOUT
         ================================================================ -->
    <ng-template #standardLayout>

      <!-- Search Panel -->
      <mat-card>
        <app-study-search-form [initialPatientId]="quickFilterPatientId"
                               [initialPatientName]="initialPatientName"
                               [isLoading]="isLoading"
                               (clear)="studies = []; historyStack = []; nextPageToken = null; quickFilterPatientId = null"
                               (search)="onSearch($event)">
        </app-study-search-form>
        <!-- Quota bar: all users (Hub and Spoke) in SEND mode -->
        <app-cmove-quota-bar *ngIf="exchangeAction === 'SEND' && quotaBarOwnerID"
                             [ownerID]="quotaBarOwnerID">
        </app-cmove-quota-bar>
      </mat-card>

      <!-- C-MOVE Progress Panel -->
      <mat-card *ngIf="activeMoveJobs.size > 0"
                class="move-progress-card">
        <div class="move-progress-header">
          <mat-icon class="move-progress-icon">
            send
          </mat-icon>
          <span class="move-progress-title">
            Sending Images
          </span>
          <span class="move-progress-subtitle">
            {{ activeMoveJobs.size }} transfer(s)
          </span>
          <span class="spacer"></span>
          <button *ngIf="allJobsDone"

                  class="done-button"
                  color="primary"

                  mat-flat-button
                  (click)="dismissMoveJobs()">
            <mat-icon>
              check
            </mat-icon>
            I'm Done
          </button>
        </div>
        <div class="move-job-list">
          <div *ngFor="let job of activeMoveJobsList"
               class="move-job-row">
            <div class="move-job-top">
              <span class="move-job-description">
                {{job.studyDescription}}
              </span>
              <span class="move-job-status"
                    [class.status-failure]="job.status === 'Failure'"
                    [class.status-running]="job.status === 'Running' || job.status === 'Pending' || job.status === 'Retry'"
                    [class.status-success]="job.status === 'Success'">
                {{ job.status || 'Pending' }}
                <span *ngIf="job.status === 'Running' && job.progress != null">
                  — {{ job.progress }}%
                </span>
              </span>
            </div>
            <mat-progress-bar [color]="job.status === 'Failure' ? 'warn' : 'primary'"
                              [mode]="job.status === 'Running' ? 'determinate' : (job.status === 'Success' || job.status === 'Failure' ? 'determinate' : 'indeterminate')"
                              [value]="job.status === 'Success' ? 100 : (job.progress || 0)">
            </mat-progress-bar>
            <div *ngIf="job.error"
                 class="move-job-error">
              <mat-icon>
                error_outline
              </mat-icon>
              {{ job.error }}
            </div>
          </div>
        </div>
      </mat-card>

      <!-- Session Summary (receipt shown after "I'm Done") -->
      <mat-card *ngIf="sessionSummary && activeMoveJobs.size === 0"
                class="session-summary-card">
        <div class="summary-header">
          <mat-icon class="summary-icon"
                    [class.icon-partial]="sessionSummary.failureCount > 0">
            {{ sessionSummary.failureCount === 0 ? 'check_circle' : 'warning' }}
          </mat-icon>
          <div class="summary-heading">
            <span class="summary-title">Send Complete</span>
            <span class="summary-subtitle">
              {{ sessionSummary.successCount }} sent to {{ sessionSummary.targetFacilityName }}
              <span *ngIf="sessionSummary.failureCount > 0"> · {{ sessionSummary.failureCount }} failed</span>
              · {{ sessionSummary.sentAt | date:'h:mm a' }}
            </span>
          </div>
          <span class="spacer"></span>
          <button class="done-button"
                  color="primary"
                  mat-flat-button
                  (click)="dismissSummary()">
            <mat-icon>close</mat-icon>
            Close
          </button>
        </div>
        <div class="summary-job-list">
          <div *ngFor="let entry of sessionSummary.entries"
               class="summary-job-row">
            <mat-icon class="summary-job-icon"
                      [class.icon-success]="entry.status === 'Success'"
                      [class.icon-failure]="entry.status !== 'Success'">
              {{ entry.status === 'Success' ? 'check_circle_outline' : 'error_outline' }}
            </mat-icon>
            <div class="summary-job-text">
              <span class="summary-job-description">{{ entry.studyDescription }}</span>
              <span *ngIf="entry.error" class="summary-job-error">{{ entry.error }}</span>
            </div>
          </div>
        </div>
      </mat-card>

      <!-- Results Area -->
      <mat-card class="fx-flex-grow results-card">
        <app-studies-results-table [activeFiltersDescription]="activeFiltersDescription"
                                   [availableModalities]="availableModalities"
                                   [hasNextPage]="!!nextPageToken"
                                   [hasPreviousPage]="historyStack.length > 0"
                                   [hubShareMap]="hubShareMap"
                                   [isLoading]="isLoading"
                                   [isSpokeUser]="isSpokeUser"
                                   [pageSize]="pageSize"
                                   [patientExistsMap]="patientExistsMap"
                                   [shareMap]="shareMap"
                                   [showSendAction]="showSendAction"
                                   [showSendDialog]="!targetFacilityId"
                                   [showSendUnavailableHint]="showSendUnavailableHint"
                                   [showViewDownloadActions]="exchangeAction !== 'SEND'"
                                   [studies]="studies"
                                   (addPatient)="onAddPatientFromStudy($event)"
                                   (deleteMultiple)="onDeleteMultiple($event)"
                                   (deleteStudy)="onDeleteStudy($event)"
                                   (downloadMultiple)="onDownloadMultiple($event)"
                                   (downloadSingle)="onDownloadSingle($event)"
                                   (filterByPatientId)="onFilterByPatientId($event)"
                                   (limitChange)="onLimitChange($event)"
                                   (nextPage)="onNextPage()"
                                   (previousPage)="onPreviousPage()"
                                   (rowClick)="onRowClick($event)"
                                   (sendMultiple)="onSendMultiple($event.studies, $event.modality)"
                                   (sendStudy)="onSendStudyWithModality($event)"
                                   (viewStudy)="onViewStudy($event)">
        </app-studies-results-table>
      </mat-card>

      <!-- Hub SEND mode: Requests + Share History tabs -->
      <mat-tab-group *ngIf="!isSpokeUser && exchangeAction === 'SEND' && senderFacilityId"
                     class="hub-tabs"
                     animationDuration="150ms">

        <mat-tab>
          <ng-template mat-tab-label>
            Requests
            <span *ngIf="hubPendingReshareCount > 0"
                  class="tab-count-badge">
              {{hubPendingReshareCount}}
            </span>
          </ng-template>
          <div class="tab-body">
            <app-study-reshare-pending [hubFacilityId]="senderFacilityId"
                                       (pendingCount)="hubPendingReshareCount = $event">
            </app-study-reshare-pending>
          </div>
        </mat-tab>

        <mat-tab label="Share History">
          <div class="tab-body">
            <app-study-share-dashboard [hubFacilityId]="senderFacilityId">
            </app-study-share-dashboard>
          </div>
        </mat-tab>

      </mat-tab-group>

    </ng-template>

  </div>
</div>
